import { defineMessages } from 'react-intl'

export default defineMessages({
  name: { defaultMessage: 'Name' },
  price: { defaultMessage: 'Price' },
})
